import { Card, Typography, Box, Stack, useTheme } from '@mui/joy'
import { ClientLoadModel, Toll } from '@numeo/types-core'

interface Props {
    load: ClientLoadModel
    tolls?: Toll[] // Optional tolls from API response
}

export const TollDetailsCard: React.FC<Props> = ({ load, tolls }) => {
    const theme = useTheme()
    const isDarkMode = theme.palette.mode === 'dark'

    // Use provided tolls if available, otherwise fall back to load.tolls
    const tollsToDisplay = tolls || load?.tolls

    // Check if we have toll data to display
    if (!tollsToDisplay || tollsToDisplay.length === 0) {
        return null
    }

    return (
        <Card
            variant="outlined"
            sx={{
                px: 1,
                borderRadius: 'md',
                boxShadow: 'sm',
                bgcolor: 'background.surface',
            }}
        >
            <Typography level="body-xs" fontWeight="bold">
                Toll Details
            </Typography>

            <Box sx={{ maxHeight: 165, overflow: 'auto' }}>
                <Stack spacing={0.5}>
                    {tollsToDisplay.map((toll, index) => (
                        <Box
                            key={index}
                            sx={{
                                p: 0.75,
                                borderRadius: 'md',
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: isDarkMode ? '0 1px 2px rgba(0,0,0,0.15)' : '0 1px 2px rgba(0,0,0,0.05)',
                                backgroundColor: 'background.surface',
                            }}
                        >
                            {toll.details?.map((detail, detailIndex) => (
                                <Box key={detailIndex}>
                                    <Typography level="body-sm" sx={{ fontSize: '0.7rem' }}>
                                        {detail.tollSystem}
                                    </Typography>
                                    <Typography level="body-xs" color="neutral" sx={{ fontSize: '0.65rem' }}>
                                        {detail.countryCode} • ${toll.total}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Stack>
            </Box>
        </Card>
    )
}
